import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-customercomments',
    templateUrl: './customer-comments.component.html',
    standalone: false
})
export class InstallationCustomerCommentsPluginComponent {
  public comments: any[];
  public config: any;
  public editRoute = ['installation', 'customercomments', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any): void {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.comments = this.config.Comments;
  }
}
PluginComponent.plugins['installationcustomercomments'] = InstallationCustomerCommentsPluginComponent;
